import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Hook personalizado para definir títulos de páginas
 * Formato: "Nome da Página - Tenant.name"
 *
 * @param {string} pageTitle - O título específico da página
 */
export function usePageTitle(pageTitle) {
    const { currentTenant } = useAuth();

    useEffect(() => {
        if (pageTitle) {
            const tenantName = currentTenant?.name || '';
            const parts = [];

            if (pageTitle) parts.push(pageTitle);
            if (tenantName) parts.push(tenantName);

            document.title = parts.join(' - ');
        }
    }, [pageTitle, currentTenant]);
}

export default usePageTitle;

